import { render, staticRenderFns } from "./moneyManagement.vue?vue&type=template&id=bcf80d52&scoped=true&"
import script from "./moneyManagement.vue?vue&type=script&lang=js&"
export * from "./moneyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf80d52",
  null
  
)

export default component.exports